import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericDelete } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_USERID_PATH_KEY } from '@/swagger/constants/slash-keys';
import { API_DELETE_DELEGATE, KEY_DELETE_DELEGATE } from '../constants';
import { MOCK_RESPONSE_DELETE_DELEGATE } from '../mocks';

type RequestDeleteDelegate = GenericDelete<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_USERID_PATH_KEY
>['request']['path'];

export type CallParamsDeleteDelegate = Omit<RequestDeleteDelegate, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponseDeleteDelegate = unknown;

type CallErrorDeleteDelegate = {
  message: string;
  code: number;
};

type CallSelectorsDeleteDelegate = unknown;

export const deleteDelegateCall = createGeneralCall<
  CallParamsDeleteDelegate,
  CallResponseDeleteDelegate,
  CallErrorDeleteDelegate,
  CallSelectorsDeleteDelegate
>({
  id: KEY_DELETE_DELEGATE,
  url:
    ({ payload }) =>
    state => {
      const { userId } = payload;
      const org = getCurrentOrganization(state);
      return API_DELETE_DELEGATE(org as unknown as string, userId);
    },
  method: 'delete',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_DELETE_DELEGATE : undefined,
  responseExtractor: null,
});
